import { useMemo } from "react";
import Hero from "@/components/Hero";
import IntroSection from "@/components/IntroSection";
import ScrollVelocitySection from "@/components/ScrollVelocitySection";
import LastYearSection from "@/components/LastYearSection";
import PrePartyCard from "@/components/PrePartyCard";

import BigWordsSection from "@/components/BigWordsSection";
import StayInTheKnow from "@/components/StayInTheKnow";
import { LineupSection, TicketCTA } from "@/components/Sections";
import CrewSection from "@/components/CrewSection";
import Footer from "@/components/Footer";
import EarlyAccessModal from "@/components/EarlyAccessModal";
import { usePageSEO } from "@/hooks/use-page-seo";
import { buildMusicEventSchema } from "@/lib/event-schema";

const Index = () => {
  const eventJsonLd = useMemo(() => buildMusicEventSchema({
    url: "https://yachtrockdetroit.com",
    description: "Yacht Rock Detroit 2026 — Detroit's two-day waterfront music festival at The Roostertail, July 17-18. Live concerts featuring Three Dog Night, Pablo Cruise, Ambrosia, Yacht Rock Revue, and more. Summer concerts on the Detroit River with sunset views, craft cocktails, and the smoothest music ever made.",
  }), []);

  const orgJsonLd = useMemo(() => ({
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Yacht Rock Detroit",
    "url": "https://yachtrockdetroit.com",
    "logo": "https://yachtrockdetroit.com/favicon.svg",
    "sameAs": [
      "https://www.instagram.com/yachtrockdetroit/",
      "https://www.facebook.com/yachtrockdetroit/"
    ],
    "contactPoint": {
      "@type": "ContactPoint",
      "telephone": "+1-313-822-1234",
      "contactType": "customer service",
      "email": "hello@yachtrockdetroit.com"
    }
  }), []);

  const webSiteJsonLd = useMemo(() => ({
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "Yacht Rock Detroit",
    "url": "https://yachtrockdetroit.com"
  }), []);

  usePageSEO({
    title: "Yacht Rock Detroit 2026 — Detroit Waterfront Music Festival | July 17-18",
    description: "Yacht Rock Detroit 2026 is a two-day waterfront concert festival at The Roostertail in Detroit, MI — July 17-18. Live performances by Three Dog Night, Pablo Cruise, Ambrosia & more. Get tickets for Detroit's smoothest summer music festival.",
    canonical: "https://yachtrockdetroit.com/",
    keywords: "yacht rock detroit, detroit summer festival 2026, concert detroit, summer concerts detroit, upcoming concerts detroit 2026, detroit waterfront music festival, detroit music festival july 2026, live music detroit, roostertail detroit, detroit concert festival",
    jsonLd: [eventJsonLd, orgJsonLd, webSiteJsonLd],
  });

  return (
    <main>
      <Hero />
      <TicketCTA />
      <PrePartyCard />
      <LineupSection />
      <IntroSection />
      <BigWordsSection />
      <LastYearSection />
      <ScrollVelocitySection />
      <CrewSection />
      <StayInTheKnow />
      <Footer />
      <EarlyAccessModal />
    </main>
  );
};

export default Index;
